(() => {
  function init(root = document) {
    root.querySelectorAll('.rg-hero-media').forEach(media => {
      if (media.dataset.rgReady) return;
      const track = media.querySelector('.rg-photo-track');
      const slides = [...media.querySelectorAll('.rg-hero-slide')];
      const controls = [...media.querySelectorAll('[data-rg-slide]')];
      if (!track || !slides.length) return;
      media.dataset.rgReady = 'true';
      const update = () => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        controls.forEach((control, i) => control.setAttribute('aria-current', String(i === index)));
      };
      controls.forEach((control, index) => control.addEventListener('click', event => {
        event.preventDefault();
        track.scrollTo({left: index * track.clientWidth, behavior: 'auto'});
        update();
      }));
      track.addEventListener('scroll', update, {passive: true});
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => {
    init(event.target);
    if (window.Trustpilot) event.target.querySelectorAll('.trustpilot-widget').forEach(widget => window.Trustpilot.loadFromElement(widget, true));
  });
})();
